import axios from 'axios'

export const state = {}

export const getters = {
  getAdminStatuses(){
    return ['deleted','reverted','expired']
  }
}

export const mutations = {}

export const actions = {
  getStatuses({ commit }, resource) {
    return axios.get(`/status/${resource}`)
  },
}
